<div class="container">
  <ui-button-group>
    <button (click)="onClick()" ui-button uiShape="round">
      {{ buttonText }}
    </button>
    <button [uiDropdownMenu]="menu2" ui-button uiShape="round" uiTrigger="click" ui-dropdown uiPlacement="bottomRight" uiOverlayClassName="dropdown-menu">
      <i [uiTheme]="uiTheme" [uiType]="uiType" ui-icon></i>
    </button>
  </ui-button-group>

  <ui-dropdown-menu #menu2="uiDropdownMenu">
    <ng-content></ng-content>
  </ui-dropdown-menu>
</div>
